var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"cards-main__link blue-btn",attrs:{"href":this.$root.baseUrl + '/properties-for-sale'}},[_vm._v(_vm._s(_vm._f("trans")('View more')))])
}
var staticRenderFns = []

export { render, staticRenderFns }